import React from 'react'
import {
  OrderDTO,
  useConfigState,
  useOrderPrice,
  usePrice,
} from '@sentecacommerce-theme/lib'

export const AffiliateScripts = ({ data }: { data?: OrderDTO }) => {
  const config = useConfigState()

  const price = useOrderPrice(data)

  const { price: amount } = usePrice({ price: price.netPrice })

  const skuList = data?.lineItems.map((item) => item.variant.sku)

  const affiliates = {
    amount: amount.value,
    description: skuList?.join('%2C'),
    transaction: data?._id,
  }

  return (
    <>
      {data && (
        <iframe
          title="2performant"
          height="1"
          width="1"
          scrolling="no"
          marginHeight={0}
          marginWidth={0}
          frameBorder={0}
          src={`https://event.2performant.com/events/salecheck?amount=${affiliates.amount}&campaign_unique=${config.affiliates.twoPerformant.campaignUnique}&confirm=${config.affiliates.twoPerformant.confirm}&description=${affiliates.description}&transaction_id=${affiliates.transaction}`}
        />
      )}
    </>
  )
}
